import { caseStatuses } from "@/constants/caseStatuses.ts";
import { Checkbox, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";

const CaseStatusCheckboxes = () => {
    const { watch, setValue, formState } = useFormContext();
    const selectedStatuses = watch("caseStatuses") || [];
    const error = useMemo(() => {
        return formState.errors.caseStatuses;
    }, [formState.errors]);

    const handleCheckboxChange = (status: string) => {
        const updatedStatuses = selectedStatuses.includes(status)
            ? selectedStatuses.filter((r: string) => r !== status)
            : [...selectedStatuses, status];

        setValue("caseStatuses", updatedStatuses);
    };

    return (
        <Box sx={{ display: "flex" }}>
            <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                <FormLabel component="legend">Case Statuses</FormLabel>
                <FormGroup>
                    {caseStatuses.map((caseStatus) => (
                        <FormControlLabel
                            key={caseStatus.id}
                            control={
                                <Checkbox
                                    name={`caseStatuses[${caseStatus.label}]`}
                                    checked={selectedStatuses.includes(caseStatus.label)}
                                    onChange={() => handleCheckboxChange(caseStatus.label)}
                                />
                            }
                            label={caseStatus.label}
                        />
                    ))}
                    {error && <Typography color="error">{error.message?.toString()}</Typography>}
                </FormGroup>
            </FormControl>
        </Box>
    );
};

export default CaseStatusCheckboxes;
